/* eslint-disable prettier/prettier */
import axios from "axios";
import store from '@/store/store';
import { analyticsHeaderInterceptor } from '@docupet/component-library/src/utils/analyticsHeader';

const ACCESS_DENIED_MESSAGE = 'Access denied to this field.';

const getBaseUrl = () => {
  const url = global.API_URL || process.env.VUE_APP_API_URL;

  if (url) {
    return `${url}graphql`;
  }
}

const getRESTBaseUrl = () => {
  const url = global.API_URL || process.env.VUE_APP_API_URL;

  if (url) {
    return `${url}api`;
  }
}

const config = {
  baseURL: getBaseUrl(),
  timeout: 60000, // 1 minutes
  withCredentials: true
};
const instance = axios.create(config);

export const anonymous = axios.create(config);
export const rest = axios.create({
  ...config,
  baseURL: getRESTBaseUrl()
});
export default instance;

instance.CancelToken = axios.CancelToken;
instance.isCancel = axios.isCancel;
anonymous.CancelToken = axios.CancelToken;
anonymous.isCancel = axios.isCancel;
rest.CancelToken = axios.CancelToken;
rest.isCancel = axios.isCancel;


function addAcceptLanguageHeader(config) {
  const locale = window.__INITIAL_STATE__.locale;
  if (locale) {
    config.headers['Accept-Language'] = locale;
  }
  return config;
}

function authenticateRequest(config) {
  const newToken = store.getters['getToken'] || process.env.VUE_APP_TOKEN;
  if (newToken) {
    config.headers["Authorization"] = newToken;
  }
  return addAcceptLanguageHeader(config);
}

/**
 * Receives GraphQL response and rejects if there is no data and there are errors.
 *
 * @param response
 */
function handleGraphQLResponse({ data: results }) {
  const { data, errors, extensions } = results;
  const success = data ? Object.keys(data).filter((key) => data[key] !== null).length : 0;
  const forbidden = (errors?.find(e => e.message === ACCESS_DENIED_MESSAGE) ?? extensions?.warnings?.find(w => w.message === ACCESS_DENIED_MESSAGE)) !== undefined;

  if (forbidden) {
    const citySlug = store.getters['getCitySlug'];
    const cityParam = citySlug ? `&city=${encodeURIComponent(citySlug)}` : '';
    window.location.href = `${window.BASE_URL}/login?error=session_expired${cityParam}`;
  }

  // We did not get any results, and there were errors so reject the response.
  if (!success && (errors && errors.length)) {
    return Promise.reject({
      message: errors
    });
  } else {
    return data;
  }
}

function handleError({ response, request, message }) {
  if (response) {
    const { status } = response;

    return Promise.reject({
      error: status
    });
  } else if (request) {
    return Promise.reject({
      error: request.status
    });
  } else {
    return Promise.reject({
      error: message
    });
  }
}

rest.interceptors.request.use(
  authenticateRequest,
  error => Promise.reject(error)
);

instance.interceptors.request.use(
  authenticateRequest,
  error => Promise.reject(error)
);

anonymous.interceptors.request.use(
  addAcceptLanguageHeader,
  error => Promise.reject(error)
);
instance.interceptors.request.use(analyticsHeaderInterceptor, (error) => Promise.reject(error));
anonymous.interceptors.request.use(analyticsHeaderInterceptor, (error) => Promise.reject(error));

instance.interceptors.response.use(
  handleGraphQLResponse,
  handleError
);
anonymous.interceptors.response.use(
  handleGraphQLResponse,
  ({ response, request, message }) => {
    if (response) {
      return Promise.reject({
        error: status
      });
    } else if (request) {
      return Promise.reject({
        error: request.status
      });
    } else {
      return Promise.reject({
        error: message
      });
    }
  }
);
